import { render, staticRenderFns } from "./ManageResume.vue?vue&type=template&id=0651d974&scoped=true&"
import script from "./ManageResume.vue?vue&type=script&lang=js&"
export * from "./ManageResume.vue?vue&type=script&lang=js&"
import style0 from "./ManageResume.vue?vue&type=style&index=0&id=0651d974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0651d974",
  null
  
)

export default component.exports